import React, { useState } from 'react';
import { EventTrackAndLogData, PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import ApiService from '../Services/ApiService';

const useProcesarPagoCobroMinimo = () => {
    const { REACT_APP_APIPAYWALL } = process.env;
    const [isLoading, setIsLoading] = useState(null);
    const [responsePago, setResponsePago] = useState(null);
    const [error, setError] = useState(null);

    const outFunc = async (data) => {
        setIsLoading(true);
        PageViewTrackAndLogData('procesar_pago');
        return ApiService.post(`${REACT_APP_APIPAYWALL}Venta/ProcesarPagoCobroMinimo`, data) 
            .then((data) => {
                if (data && data.code === '0000') {
                    setResponsePago(data.response?.ventaResponse);
                    setIsLoading(false);
                } else {
                    EventTrackAndLogData('error-pago', data.message);
                    setError(data.message);
                    setIsLoading(false);
                }
                return Promise.resolve(data);
            })
            .catch((error) => {
                EventTrackAndLogData('error-pago', error);
                setError(error);
                setIsLoading(false);
                return Promise.reject(error);
            });
    };

    return [responsePago, error, isLoading, outFunc];
};

export default useProcesarPagoCobroMinimo;